"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    iconButtonCompoundVariants: ()=>iconButtonCompoundVariants,
    iconButtonDisabledVariants: ()=>iconButtonDisabledVariants,
    iconButtonEmphases: ()=>iconButtonEmphases,
    iconButtonEmphasisVariants: ()=>iconButtonEmphasisVariants,
    iconButtonShadowVariants: ()=>iconButtonShadowVariants,
    iconButtonSizeVariants: ()=>iconButtonSizeVariants,
    iconButtonSizes: ()=>iconButtonSizes,
    iconButtonSlots: ()=>iconButtonSlots,
    iconButtonTypeVariants: ()=>iconButtonTypeVariants,
    iconButtonTypes: ()=>iconButtonTypes
});
const iconButtonTypeVariants = {
    plainPrimary: {},
    plainSecondary: {},
    primary: {},
    secondary: {},
    plainFavorite: {}
};
const iconButtonTypes = Object.keys(iconButtonTypeVariants);
const iconButtonSizeVariants = {
    '3xs': {
        wrapperSlot: 'min-h-4 min-w-4',
        buttonSlot: 'after:-left-2 after:-top-2 after:w-8 after:h-8',
        tapSpaceSlot: '-left-2 -top-2 w-8 h-8',
        iconSlot: 'h-4 w-4'
    },
    '2xs': {
        wrapperSlot: 'min-h-5 min-w-5',
        buttonSlot: 'after:-left-2 after:-top-2 after:w-9 after:h-9',
        tapSpaceSlot: '-left-2 -top-2 w-9 h-9',
        iconSlot: 'h-5 w-5'
    },
    xs: {
        wrapperSlot: 'min-h-6 min-w-6',
        buttonSlot: 'after:-left-2 after:-top-2 after:w-10 after:h-10',
        tapSpaceSlot: '-left-2 -top-2 w-10 h-10',
        iconSlot: 'h-6 w-6'
    },
    sm: {
        wrapperSlot: 'min-h-8 min-w-8',
        buttonSlot: 'after:-left-1 after:-top-1 after:w-10 after:h-10',
        tapSpaceSlot: '-left-1 -top-1 w-10 h-10',
        iconSlot: 'h-6 w-6'
    },
    md: {
        wrapperSlot: 'min-h-10 min-w-10',
        buttonSlot: 'after:-left-1 after:-top-1 after:w-12 after:h-12',
        tapSpaceSlot: '-left-1 -top-1 w-12 h-12',
        iconSlot: 'h-6 w-6'
    },
    lg: {
        wrapperSlot: 'min-h-12 min-w-12',
        iconSlot: 'h-7 w-7'
    }
};
const iconButtonSizes = Object.keys(iconButtonSizeVariants);
const iconButtonEmphasisVariants = {
    regular: {},
    medium: {},
    bold: {}
};
const iconButtonEmphases = Object.keys(iconButtonEmphasisVariants);
const iconButtonSlots = {
    buttonSlot: [
        'relative antialiased transition-colors duration-400 rounded-action-md cursor-pointer transition ',
        'focus-visible:outline-2 group focus-visible:outline-offset-2 focus-visible:outline-actionPrimary-12',
        "after:content-[''] after:absolute  after:opacity-0"
    ],
    tapSpaceSlot: 'absolute opacity-0 bg-transparent',
    wrapperSlot: 'rounded-action-md flex items-center justify-center transition',
    iconSlot: 'transition'
};
const iconButtonShadowVariants = {
    true: {
        buttonSlot: 'shadow-sm hover:shadow-lg'
    }
};
const iconButtonDisabledVariants = {
    true: {
        buttonSlot: 'cursor-not-allowed shadow-none',
        wrapperSlot: 'cursor-not-allowed'
    }
};
const iconButtonCompoundVariants = [
    {
        type: 'plainFavorite',
        active: true,
        class: {
            iconSlot: 'text-favorite-8 group-hover:text-favorite-9'
        }
    },
    {
        type: 'plainFavorite',
        active: false,
        class: {
            iconSlot: 'text-neutral-5 group-hover:text-neutral-6'
        }
    },
    {
        emphasis: 'regular',
        type: 'plainPrimary',
        class: {
            wrapperSlot: 'group-hover:bg-actionPrimary-13/10',
            iconSlot: 'text-actionPrimary-8 group-hover:text-actionPrimary-9'
        }
    },
    {
        emphasis: 'regular',
        type: 'plainSecondary',
        class: {
            wrapperSlot: 'group-hover:bg-actionSecondary-13/10',
            iconSlot: 'text-actionSecondary-13 group-hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'regular',
        type: 'primary',
        class: {
            wrapperSlot: 'group-hover:bg-actionPrimary-9 bg-actionPrimary-8',
            iconSlot: 'group-hover:text-actionPrimary-4 text-actionPrimary-3'
        }
    },
    {
        emphasis: 'regular',
        type: 'secondary',
        class: {
            wrapperSlot: 'group-hover:bg-actionSecondary-9 bg-actionSecondary-8',
            iconSlot: 'group-hover:text-actionSecondary-4 text-actionSecondary-3'
        }
    },
    {
        emphasis: 'medium',
        type: 'plainPrimary',
        class: {
            wrapperSlot: 'group-hover:bg-actionPrimary-13/10',
            iconSlot: 'text-actionPrimary-8 group-hover:text-actionPrimary-9'
        }
    },
    {
        emphasis: 'medium',
        type: 'plainSecondary',
        class: {
            wrapperSlot: 'group-hover:bg-actionSecondary-13/10',
            iconSlot: 'text-actionSecondary-13 group-hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'medium',
        type: 'primary',
        class: {
            wrapperSlot: 'group-hover:bg-actionPrimary-9 bg-actionPrimary-8',
            iconSlot: 'group-hover:text-actionPrimary-4 text-actionPrimary-3'
        }
    },
    {
        emphasis: 'medium',
        type: 'secondary',
        class: {
            wrapperSlot: 'group-hover:bg-actionSecondary-1 bg-actionSecondary-1/80',
            iconSlot: 'group-hover:text-actionSecondary-4 text-actionSecondary-3'
        }
    },
    {
        emphasis: 'bold',
        type: 'plainPrimary',
        class: {
            wrapperSlot: 'group-hover:bg-actionPrimary-3/10 text-actionPrimary-3',
            iconSlot: 'group-hover:text-actionPrimary-3'
        }
    },
    {
        emphasis: 'bold',
        type: 'plainSecondary',
        class: {
            wrapperSlot: 'group-hover:bg-actionSecondary-1/10 text-actionSecondary-1',
            iconSlot: 'group-hover:text-actionSecondary-1'
        }
    },
    {
        emphasis: 'bold',
        type: 'primary',
        class: {
            wrapperSlot: 'group-hover:bg-actionPrimary-4 bg-actionPrimary-3',
            iconSlot: 'group-hover:text-actionPrimary-9 text-actionPrimary-8'
        }
    },
    {
        emphasis: 'bold',
        type: 'secondary',
        class: {
            wrapperSlot: 'group-hover:bg-actionSecondary-9/40 bg-actionSecondary-8/20',
            iconSlot: 'group-hover:text-actionSecondary-9 text-actionSecondary-1'
        }
    },
    {
        type: 'plainPrimary',
        disabled: true,
        class: {
            wrapperSlot: 'group-hover:bg-transparent',
            iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
        }
    },
    {
        type: 'plainSecondary',
        disabled: true,
        class: {
            wrapperSlot: 'group-hover:bg-transparent',
            iconSlot: 'text-actionSecondary-6 group-hover:text-actionSecondary-6'
        }
    },
    {
        type: 'primary',
        disabled: true,
        class: {
            wrapperSlot: 'bg-actionPrimary-2 group-hover:bg-actionPrimary-2',
            iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
        }
    },
    {
        type: 'secondary',
        disabled: true,
        class: {
            wrapperSlot: 'bg-actionPrimary-2 group-hover:bg-actionPrimary-2',
            iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
        }
    },
    {
        emphasis: 'bold',
        type: 'plainPrimary',
        disabled: true,
        class: {
            iconSlot: 'text-actionPrimary-1/40 group-hover:text-actionPrimary-1/40'
        }
    },
    {
        emphasis: 'bold',
        type: 'plainSecondary',
        disabled: true,
        class: {
            iconSlot: 'text-actionSecondary-1/40 group-hover:text-actionSecondary-1/40'
        }
    },
    {
        emphasis: 'bold',
        type: 'primary',
        disabled: true,
        class: {
            wrapperSlot: 'bg-actionPrimary-1/20 group-hover:bg-actionPrimary-1/20',
            iconSlot: 'text-actionPrimary-1/40 group-hover:text-actionPrimary-1/40'
        }
    },
    {
        emphasis: 'bold',
        type: 'secondary',
        disabled: true,
        class: {
            wrapperSlot: 'bg-actionSecondary-1/20 group-hover:bg-actionSecondary-1/20',
            iconSlot: 'text-actionSecondary-1/40 group-hover:text-actionSecondary-1/40'
        }
    },
    {
        shadow: true,
        disabled: true,
        class: {
            buttonSlot: 'shadow-none hover:shadow-none'
        }
    }
];
exports.iconButtonCompoundVariants = __webpack_exports__.iconButtonCompoundVariants;
exports.iconButtonDisabledVariants = __webpack_exports__.iconButtonDisabledVariants;
exports.iconButtonEmphases = __webpack_exports__.iconButtonEmphases;
exports.iconButtonEmphasisVariants = __webpack_exports__.iconButtonEmphasisVariants;
exports.iconButtonShadowVariants = __webpack_exports__.iconButtonShadowVariants;
exports.iconButtonSizeVariants = __webpack_exports__.iconButtonSizeVariants;
exports.iconButtonSizes = __webpack_exports__.iconButtonSizes;
exports.iconButtonSlots = __webpack_exports__.iconButtonSlots;
exports.iconButtonTypeVariants = __webpack_exports__.iconButtonTypeVariants;
exports.iconButtonTypes = __webpack_exports__.iconButtonTypes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "iconButtonCompoundVariants",
    "iconButtonDisabledVariants",
    "iconButtonEmphases",
    "iconButtonEmphasisVariants",
    "iconButtonShadowVariants",
    "iconButtonSizeVariants",
    "iconButtonSizes",
    "iconButtonSlots",
    "iconButtonTypeVariants",
    "iconButtonTypes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
